<template>
    <div id="page-section">        
        <link rel="canonical" href="https://getbootstrap.com/docs/5.1/examples/dashboard/">
        <link href="../assets/dist/css/bootstrap.min.css" rel="stylesheet">

        <!-- header -->        
        <header class="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow page-header" style="box-shadow: 0 3px 4px 0 rgb(0 0 0 / 20%), 0 3px 3px -2px rgb(0 0 0 / 14%), 0 1px 8px 0 rgb(0 0 0 / 12%) !important; position: fixed; top: 0; width: 100%; height: 58px">
            <!-- Vitrafy logo -->
            <div id="lifechain-logo" class="navbar-brand col-md-3 col-lg-2 d-md-block logo-link" style="margin: 0; max-width: 292px; background-color: #212529 !important; height: 58px;">
                <img style="height: 34px; position: absolute; top: 11px; left: 30px; cursor: pointer;" src="../../assets/images/vitrafy-logo-white.png" @click="devicesClick()" />
            </div>
        </header>

        <!-- main content -->
        <div class="container-fluid" style="height: calc(100vh - 90px); overflow: auto; position: relative; top: 58px;">
            <div class="row">

                <!-- side nav -->
                <nav id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
                    <div class="position-sticky pt-3">
                        <ul class="nav flex-column">
                            <div v-for="item in sideNav" v-bind:key="item.id">
                                <li class="nav-item sidenav-item bc-active">
                                    <div class="side-nav-icon">
                                        <i :class="[item.icon]"></i>
                                    </div>
                                    <span>{{ item.label }}</span>
                                </li>
                            </div>
                        </ul> 
                    </div>
                </nav>

                <!-- pages -->
                <main class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                    <div class="section-container" style="margin-bottom: 100px;">

                            <!-- heading -->
                            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom dashboard-heading">
                                <h1 class="h2"><i class="fa-solid fa-chart-line" style="padding-right: 10px"></i> Sensor Dashboard</h1>
                            </div>

                            <!-- loading spinner -->
                            <div id="lifelink-loading">
                                <div class="lds-facebook"><div></div><div></div><div></div></div>
                                <div>Connecting to live data feed...</div>
                            </div>     

                            <!-- lifelink dashboard -->
                            <div id="lifelink-container" style="display: none;">

                                <h4 class="device-filter-heading">Vitrafy Manufacturing Area</h4>
                                <div class="device-filter-container">
                                    <div v-for="item in items" v-bind:key="item.id">
                                        <div v-if="item.location == 'Vitrafy Lab' && item.id == 'Packaging Device 3'" class="card-container">
                                            <sensor-card :item="item" />
                                        </div>
                                    </div>
                                </div>

                                <h4 class="device-filter-heading">Vitrafy Design Lab</h4>
                                <div class="device-filter-container">
                                    <div v-for="item in items" v-bind:key="item.id">
                                        <div v-if="item.location == 'Vitrafy Design Lab' && item.id == 'Packaging Device 2'" class="card-container">
                                            <sensor-card :item="item" />
                                        </div>
                                    </div>
                                </div> 

                            </div>

                    </div>
                </main>

            </div>
        </div>

        <!-- Footer -->
        <footer id="footer" class="footer mt-auto main-footer">
            <div class="container">
                <span id="footer-copyright" style="color: hsla(0,0%,100%,.55);">Copyright © 2023 Vitrafy Life Sciences Ltd </span>
                <span id="footer-version" style="color: hsla(0,0%,100%,.55); float: left;">Sensor Dashboard Version {{ version }}</span>
            </div>
        </footer>
        
    </div>    
</template>

<script>
    import SensorCard from '@/components/SensorDashboard/SensorCard.vue';


    export default {
        name: 'sensor-dashboard',
        components: {
            SensorCard,
        },
        data: function () {
            return {
                version: "1.0.0-alpha",
                showWallet: true,
                showNFT: false,
                sideNav: [
                    { id: 1, label: "Sensor Dashboard", icon: "fa-solid fa-chart-line", voice: "loading your personal dashboard", enabled: false, restricted: true, selected: false, subItems: [], subItemsExpanded: false },
                ],
                selectedSideNav: { id: null, label: null, icon: null, enabled: null, restricted: null, selected: null },
                dashboardDynamicGreeting: "not set",
                detectingLocation: false,
                process_location_description: null,
                process_location: null,
                process_doctor_name: null,
                process_doctor_title: null,
                process_doctor_firstname: null,
                process_doctor_surname: null,
                process_doctor_phone: null,
                process_doctor_email: null,
                process_doctor_profession: null,
                process_doctor_reg_number: null,
                process_doctor_reg_status: null,
                process_doctor_reg_status_options: [{ text: 'Select One', value: null }, 'Registered', 'Not registered'],
                locationMotSet: true,
                processInProgress: false,
                process_1_1: true,
                process_1_2: false,
                infoBoxClosed_location: true,
                infoBoxClosed_patient: true,
                infoBoxClosed_doctor: true,
                infoBoxClosed_sample: true,
                infoBoxClosed_sample_checks: true,
                infoBoxClosed_sample_reg: true,
                infoBoxClosed_device: true,
                infoBoxClosed_process: true,
                infoBoxClosed_1: true,
                infoBoxClosed_2: true,
                infoBoxClosed_3: true,
                infoBoxClosed_4: true,
                infoBoxClosed_5: true,
                infoBoxClosed_6: true,
                infoBoxClosed_7: true,
                infoBoxClosed_8: true,
                infoBoxClosed_9: true,
                infoBoxClosed_10: true,
                infoBoxClosed_11: true,
                infoBoxClosed_12: true,
                restoreVoiceTestLoading: false,
                voiceTestLoading: false,
                voiceChangeLoading: false,
                lifeLinkView: "type",
                lifeLinkViewOptions: [{ value: 'type', text: 'Type'}, { value: 'location', text: 'Location' }],
                loadingVoices: false,
                voices: [],
                voiceEngineSelected: 'neural',
                voiceEngineOptions: [{ item: 'neural', name: 'Neural' }, { item: 'standard', name: 'Standard' }],
                voiceLanguageSelected: '',
                voiceLanguageOptions: [],
                voiceSelected: '',
                voiceOptions: [],
                smartContractName: 'CONTRACT NAME',
                userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
                //userInfo: UserInfoStore.state.cognitoInfo,
                //restrictedLifeLinkUser: UserInfoStore.state.restrictedLifeLinkUser,
                userName: "user",
                info: null,
                apiData: "testData",
                items: [],
                blockchain: [],
                blockchainInProgress: [],
                blockchainInProgressCount: '',
                blockchainCompleted: [],
                blockchainCompletedCount: '',
                blockchainTemplates: [],
                blockchainTemplatesCount: '',
                testData: [],
                selectedBlock: {TempData: {stages: {}}},
                contractName: 'new contract',
                contractApplication: null,
                contractApplicationOptions: [{ text: 'Select Application', value: null }, 'CAR-T'],
                contractTemplate: null,
                contractTemplateOptions: [{ text: 'Select Template', value: null }, 'CAR-T Test Template 1'],
                sensorData: [],
                trackingDataAll: [],
                trackingDataRpi4G: [],
                trackingDataRpi4G02: [],
                autofetch: false,
                active: false,
                tabTrackingDataAll: '',
                tabTrackingDataRpi4G : '',
                tabTrackingDataRpi4G02 : '',
                tab: 0,
                fetchTrackingData: false,
                fetchSensorData: false,
                fetchDeviceData: false,
                designermodalOpen: false,
                errorDetails: null,
                audioPath: "https://mcaloon.org/voice/",
                AIChecked: false,
                voiceText: "Hi, my name is Lily. I'm the LifeChain Virtual Assistant. How can I help you today?",
                selectedMilestoneText: null,
                selectedMilestoneID: null,
                selectedMilestoneType: null,
                selectedMilestoneTimestamp: null,
                deviceTempAndFlow: [
                    {
                        name: "Vitrafy-00001",
                        temp: null,
                        belowZero: false,
                        flow: null
                    },
                    {
                        name: "Vitrafy-00002",
                        temp: null,
                        belowZero: false,
                        flow: null
                    },
                    {
                        name: "Vitrafy-00004",
                        temp: null,
                        belowZero: false,
                        flow: null
                    },
                    {
                        name: "Vitrafy-00006",
                        temp: null,
                        belowZero: false,
                        flow: null
                    },
                    {
                        name: "Vitrafy-00009",
                        temp: null,
                        belowZero: false,
                        flow: null
                    }
                ],
                DeviceCurrentTemp0004: null,
                DeviceFlowActual0004: null,
            };
        },
        methods: {
            sideNavClick(label) {    
                var saveSideNavLocation = true;
                this.fetchDeviceData = false; 

                if(label == "Blockchain") {
                    saveSideNavLocation = false;
                }

                // cater for new subitmes
                if(label == "Human" || label == "Aquaculture") {
                    this.sideNav[4].subItemsExpanded = true;
                }

                for(var i = 0; i < this.sideNav.length; i++) {
                    for(var x = 0; x < this.sideNav[i].subItems.length; x++) {
                        if (this.sideNav[i].subItems[x].label == label) { 
                            this.sideNav[i].subItems[x].selected = true;
                            this.selectedSideNav = this.sideNav[i].subItems[x];
                        } else {
                            //this.fetchDeviceData = false;
                            if (saveSideNavLocation) {
                                localStorage.nav = label;
                            }                              
                            this.sideNav[i].subItems[x].selected = false;
                        }
                    }

                    if (this.sideNav[i].label == label) { 
                        this.sideNav[i].selected = true;
                        
                        if(label == "Blockchain") {
                            // open/close blockchain menu 
                            if(this.sideNav[i].subItemsExpanded) {
                                this.sideNav[i].subItemsExpanded = false;
                            } else {
                                this.sideNav[i].subItemsExpanded = true;
                            }
                        } else {
                            //this.fetchDeviceData = false;
                            if (saveSideNavLocation) {
                                localStorage.nav = label;
                            }                               
                            this.selectedSideNav = this.sideNav[i];
                        } 

                        this.playSound("play", this.selectedSideNav.voice);

                        if(this.selectedSideNav.label == "LifeLink") { 
                            this.getLifeLinkData();
                            // this.getMachineTempData('Vitrafy-00001');
                            // this.getMachineTempData('Vitrafy-00002');
                            // this.getMachineTempData('Vitrafy-00004');
                            // this.getMachineTempData('Vitrafy-00006');
                            // this.getMachineTempData('Vitrafy-00009');
                            this.fetchDeviceData = true;    
                        }
                    
                        if(this.selectedSideNav.label == "Blockchain v1") { 
                            this.getBlockchain();
                        }
                    } else { 
                        this.sideNav[i].selected = false;
                    }
                }

                this.closeNav();
            },
            processCommitToBlockchain() {
                console.log("processCommitToBlockchain clicked");
            },
            detectLocation() {
                console.log("detectLocation clicked");
                this.detectingLocation = true;  

                setTimeout(() => {
                    this.detectingLocation = false;    
                    this.locationMotSet = false;
                    this.process_location = "45 Selkirk Drive, Wendouree VIC 3355 Australia"                    
                }, 1000);
            },
            async assistantTestModal() {
                this.loadingVoices = true;
                console.log("assistantTestModal clicked!");

                let headers = {
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };                       

                try {
                    const response = await this.$http.get(
                        "https://mcaloon.org/getLanguages",
                        {headers: headers}
                    );
                    
                    this.voices = response.data.Voices; 
                    var languageList = [];

                    // create distinct list of available Languages
                    this.voices.forEach(function(voice) {
                        var item = {
                            value: voice.LanguageCode,
                            text: voice.LanguageName + " (" + voice.LanguageCode + ")",
                        }
                        
                        // add first item
                        if(languageList.length < 1) {
                            languageList.push(item);
                        }

                        // only add if the Language does not already exist
                        var exists = false;
                        languageList.forEach(function(i) {
                            if(item.value == i.value) {
                                exists = true;
                            }
                        })
                        if(!exists) {
                            languageList.push(item);
                        }
                    })

                    // adjust LanguageName (move English to the start if it exists) 
                    languageList.forEach(function(item) {
                        var nameArr = item.text.split(" ");
                        var exists = false;
                        var arrIndex = 0;
                        
                        for(var i = 0; i < nameArr.length; i++) {
                            if(nameArr[i] == "English") {
                                exists = true;
                                arrIndex = i;
                            } 
                        }

                        if(exists) {
                            nameArr.splice(arrIndex, 1);
                            var nameAdjusted = "English,";
                            nameArr.forEach(function(item) {
                                nameAdjusted = nameAdjusted + " " + item;
                            });
                            item.text = nameAdjusted;
                        }
                    });

                    // alphabetically order languageList
                    languageList.sort((a, b) => a.text.localeCompare(b.text))

                    // assign to observable for select component
                    this.voiceLanguageOptions = languageList;

                    // loading complete
                    this.loadingVoices = false;

                    this.voiceSelected = localStorage.voiceSelected;
                    this.voiceLanguageSelected = localStorage.voiceLanguageSelected;

                    this.getVoices();
                    //this.voiceSelected = "Olivia,neural";
                    //this.voiceEngineSelected  = "neural";

                } catch (error) {
                    console.log(error);
                }
            },
            getVoices() {
                var voiceList = [];
                var lc = this.voiceLanguageSelected;

                // get voices for selected language
                this.voices.forEach(function(voice) {
                    if(voice.LanguageCode == lc) {
                        voice.SupportedEngines.forEach(function(engine) {
                            var item = {
                                value: voice.Id + "," + engine,
                                text: voice.Name + " (" + engine + ")"
                            }
                            if(engine == "standard") {
                                item.text = voice.Name;
                            }
                            voiceList.push(item);
                        })
                    }
                })

                // assign values elements
                this.voiceOptions = voiceList;
                //this.voiceSelected = this.voiceOptions[0].value;

                // if current voice not in list select the top one
                var voiceInList = false;

                for(var i = 0; i < this.voiceOptions.length; i++) {
                    console.log("-----");
                    console.log(this.voiceSelected + " " + this.voiceOptions[i].value);
                    if(this.voiceSelected == this.voiceOptions[i].value) {
                        voiceInList = true;
                    }
                }

                if(!voiceInList) {
                    this.voiceSelected = this.voiceOptions[0].value;
                }
            },
            getEngine() {
                this.voiceEngineSelected = this.voiceSelected.split(",")[1];
            },
            async sendInfo(block, designerModal) {
                console.log("Inside sendinfo block")
                console.log("block = " + block.ID);

                // reset info boxes
                this.infoBoxClosed_1 = true;
                this.infoBoxClosed_2 = true;
                this.infoBoxClosed_3 = true;
                this.infoBoxClosed_4 = true;
                this.infoBoxClosed_5 = true;
                this.infoBoxClosed_6 = true;
                this.infoBoxClosed_7 = true;
                this.infoBoxClosed_8 = true;
                this.infoBoxClosed_9 = true;
                this.infoBoxClosed_10 = true;
                this.infoBoxClosed_11 = true;
                this.infoBoxClosed_12 = true;

                await this.ReadAssetHistory(block);
                
                this.selectedBlock = block;

                // block history
                console.log(block.history);

                document.getElementById("blockchain-data-loading-modal").style.display = 'none';
                document.getElementById("blockchain-modal").style.display = 'block';

                if(designerModal) {
                    console.log("designer modal opened");
                    this.designermodalOpen = true;
                    console.log(this.selectedBlock.TempData);

                    var data = this.selectedBlock.TempData;

                    console.log("data = ");
                    console.log(data.uuid);
                    console.log(data.stages[0].stageType);

                    //this.selectedBlock.design = JSON.parse(this.selectedBlock.TempData);
                    //console.log(this.selectedBlock.design);
                } else {
                    console.log("block modal opened and NOT designer modal");
                }

            },
            selectedMilestone(milstoneText, milestoneID, milestoneType, milestoneTimestamp, inprogress) {
                // reset input fields
                this.locationMotSet = true;
                this.detectingLocation = false,
                this.process_location_description = null;
                this.process_location = null;
                this.process_doctor_name = null;
                this.process_doctor_title = null;
                this.process_doctor_surname = null;
                this.process_doctor_firstname = null;
                this.process_doctor_phone = null;
                this.process_doctor_email = null;
                this.process_doctor_profession = null;
                this.process_doctor_reg_number = null;
                this.process_doctor_reg_status = null;
                
                // check if process is in progress
                if(inprogress) {
                    this.processInProgress = true;
                } else {
                    this.processInProgress = false;
                }
                
                // close any expanded dropdowns
                this.infoBoxClosed_location = true;
                this.infoBoxClosed_patient = true;
                this.infoBoxClosed_doctor = true;
                this.infoBoxClosed_sample = true;
                this.infoBoxClosed_sample_checks = true;
                this.infoBoxClosed_sample_reg = true;
                this.infoBoxClosed_device = true;
                this.infoBoxClosed_process = true;

                // load selected data into modal
                this.selectedMilestoneText = milstoneText;
                this.selectedMilestoneID = milestoneID;
                this.selectedMilestoneType = "Subprocess"; // overriddden
                this.selectedMilestoneTimestamp = milestoneTimestamp;
            },
            lifeLinkViewChnage() {
                localStorage.lifeLinkView = this.lifeLinkView;
            },
            uuidv4() {
                return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            )},    
            async getLifeLinkData() {
                try {
                    let url = "https://t0wxzdk096.execute-api.ap-southeast-2.amazonaws.com/beta/lifelink";
                    let headers = {
                        'x-api-key': 'NMKFcHIzMT7ToX0O9eRXW7yXA22zGM0B7ddc8Xpy'
                    };

                    const response = await this.$http.get(
                        url,
                        {headers: headers}
                    );
                    this.items = response.data.Items;

                    for (var i = 0; i < this.items.length; i++) {
                        // test device
                        this.$set(this.items[i], 'testDevice', false)
                        if (this.items[i].id == "raspi2" || this.items[i].id == "VLSENGNB011" || this.items[i].id == "raspi-4G-02") {
                            this.$set(this.items[i], 'testDevice', true)
                        }

                        // sensor device status
                        this.$set(this.items[i], 'sensorDevice', false)
                        if (this.items[i].id == "raspi2") {
                            this.$set(this.items[i], 'sensorDevice', true)
                        }
                        if (this.items[i].id == "raspi5") {
                            this.$set(this.items[i], 'sensorDevice', true)
                        }                        

                        // details
                        this.$set(this.items[i], 'details', "Cryopreservation Apparatus")
                        if (this.items[i].id == "raspi2" || this.items[i].id == "raspi5") {
                            this.$set(this.items[i], 'details', "MIoT Test Device (sensor)")
                        }
                        if (this.items[i].id == "raspi-4G-02") {
                            this.$set(this.items[i], 'details', "MIoT Test Device (4G)")
                        }                    
                        if (this.items[i].id == "VLSENGNB011") {
                            this.$set(this.items[i], 'details', "Simon's Laptop")
                        }

                        // online
                        var currentTime = new Date().getTime();
                        var diff = (currentTime - this.items[i].deviceTimestamp) / 1000;
                        this.$set(this.items[i], 'diff', diff)
                        var online = true;
                        var offline = false;

                        // if no response after 3min device is considered offline
                        if (diff > 180) {
                            online = false;
                            offline = true;
                        }
                        this.$set(this.items[i], 'online', online)
                        this.$set(this.items[i], 'offline', offline)
                        
                        // deviceCPU
                        this.items[i].deviceCPU = Math.round(this.items[i].deviceCPU * 10) / 10

                        // deviceMEM
                        var deviceMEM = (100 / this.items[i].deviceTotalMem) * this.items[i].deviceUsedMem
                        deviceMEM = Math.round(deviceMEM * 10) / 10
                        this.$set(this.items[i], 'deviceMEM', deviceMEM)

                        // Sensor Data
                        if (this.items[i].id == "raspi2" || this.items[i].id == "raspi5") {
                            var sensorDetails = this.items[i].deviceTempData.split(" ");
                            var sensorData = sensorDetails[1] + "C / " + sensorDetails[2] + "%";
                            this.SensorData = sensorData;
                            this.items[i].SensorTemp = sensorDetails[1];
                            this.items[i].SensorRH = sensorDetails[2];
                            var sensorDataTimestamp = sensorDetails[0];
                            this.$set(this.items[i], 'sensorData', sensorData)
                            this.$set(this.items[i], 'sensorDataTimestamp', sensorDataTimestamp)
                            var d = new Date();
                            var seconds = Math.round(d.getTime() / 1000);
                            var sensorTimeDiff = seconds - sensorDataTimestamp;
                            this.$set(this.items[i], 'sensorTimeDiff', sensorTimeDiff)
                            this.$set(this.items[i], 'seconds', seconds)
                        } else {
                            this.$set(this.items[i], 'sensorData', '');
                        }

                        // check if LifeLink is up to date
                        this.$set(this.items[i], 'lifeLinkUpToDate', true)
                        if(this.items[i].lifelinkVersion != '0.2.1 alpha') {
                            this.items[i].lifeLinkUpToDate = false;
                            this.items[i].lifelinkVersion = '0.1.8 alpha';
                        }

                        // rename laptop
                        // if (this.items[i].id == "VLSENGNB011") {
                        //     this.items[i].id = "Raspberry-Pi-1";
                        // }

                        // convert pi's
                        if (this.items[i].id == "raspi2") {
                            this.items[i].id = "Packaging Device 2";
                        }
                        if (this.items[i].id == "raspi-4G-02") {
                            this.items[i].id = "Packaging Device 1";
                        }
                        if (this.items[i].id == "raspi5") {
                            this.items[i].id = "Packaging Device 3";
                        }                        

                        // Add location to each device
                        if(this.items[i].id == "BioThaw-Vitrafy-00004") { this.$set(this.items[i], 'location', 'Vitrafy Lab'); }

                        if(this.items[i].id == "Vitrafy-00001") { this.$set(this.items[i], 'location', 'Huon Aquaculture (Tasmania)'); }
                        if(this.items[i].id == "Vitrafy-00002") { this.$set(this.items[i], 'location', 'BioBridge Global (USA)'); }
                        if(this.items[i].id == "Vitrafy-00003") { this.$set(this.items[i], 'location', 'BioBridge Global (USA)'); }
                        if(this.items[i].id == "Vitrafy-00004") { this.$set(this.items[i], 'location', 'Vitrafy Lab'); }
                        if(this.items[i].id == "Vitrafy-00005") { this.$set(this.items[i], 'location', 'Australian Red Cross Lifeblood (Sydney)'); }
                        if(this.items[i].id == "Vitrafy-00006") { this.$set(this.items[i], 'location', 'Vitrafy Lab'); }
                        if(this.items[i].id == "Vitrafy-00007") { this.$set(this.items[i], 'location', 'Huon Aquaculture (Tasmania)'); }
                        if(this.items[i].id == "Vitrafy-00009") { this.$set(this.items[i], 'location', 'Select Sires International (USA)'); }
                        if(this.items[i].id == "Packaging Device 1") { this.$set(this.items[i], 'location', 'Vitrafy Design Lab'); }
                        if(this.items[i].id == "Packaging Device 2") { this.$set(this.items[i], 'location', 'Vitrafy Design Lab'); }
                        if(this.items[i].id == "Packaging Device 3") { this.$set(this.items[i], 'location', 'Vitrafy Lab'); }
                        if(this.items[i].id == "VLSENGNB011") { this.$set(this.items[i], 'location', 'Vitrafy Office'); }
                        
                        // convert timestamp
                        var convertedTimestamp = new Date(this.items[i].deviceTimestamp);
                        this.$set(this.items[i], 'convertedTimestamp', convertedTimestamp);

                        // find diff in seconds 
                        var lastCommunicationSeconds = Math.round(Date.now() / 1000) - Math.round(this.items[i].deviceTimestamp / 1000)
                        if(lastCommunicationSeconds < 1) {lastCommunicationSeconds = 3;}
                        this.$set(this.items[i], 'lastCommunicationSeconds', lastCommunicationSeconds);

                        // format diff in seconds
                        this.$set(this.items[i], 'formattedLastCommunicationSeconds', this.timeCalculator(lastCommunicationSeconds));

                    }

                    // reorder devices by name (id)
                    this.items.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })

                    // move "Packaging Device 3" to the end of the items array (for UI)
                    var index = null;
                    var packagingDevice3 = null;
                    for(i = 0; i < this.items.length; i++) {
                        if(this.items[i].id == "Packaging Device 3") {
                            index = i;
                            packagingDevice3 = this.items[i];
                        }
                    }
                    this.items.splice(index, 1);
                    this.items.push(packagingDevice3);

                    // hide loading spinner and display dashboard
                    document.getElementById("lifelink-loading").style.display = 'none';
                    document.getElementById("lifelink-container").style.display = 'block';

                    // get machine temp data for specific devices (if online!);
                    for (i = 0; i < this.items.length; i++) {
                        if(this.items[i].id == "Vitrafy-00001" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00001');
                        }
                        if(this.items[i].id == "Vitrafy-00002" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00002');
                        }
                        if(this.items[i].id == "Vitrafy-00004" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00004');
                        }
                        if(this.items[i].id == "Vitrafy-00006" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00006');
                        }
                        if(this.items[i].id == "Vitrafy-00009" && this.items[i].online) {
                            this.getMachineTempData('Vitrafy-00009');
                        }                                                                     
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            async getMachineTempData(id) {
                let url = process.env.VUE_APP_MULE_PROXY_API_URI;

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };

                var data = {
                    "endpoint": "/api/devices/" + id + "/data?mode=stream"
                };

                data = JSON.stringify(data);

                try {
                    const response = await this.$http.post(
                        url,
                        data,
                        { headers: headers }
                    );

                    for (var i = 0; i < response.data.length; i++) {
                        if(response.data[i].length > 0 ) {
                            var element = response.data[i];

                            if (element[0].TagID == "analogs_lc_lrt_scaled") {
                                var temp = element[0].TagValue.toFixed(1);
                                
                                if(id == 'Vitrafy-00001') {
                                    this.deviceTempAndFlow[0].temp = temp;
                                    this.deviceTempAndFlow[0].belowZero = (temp < 1)
                                }
                                if(id == 'Vitrafy-00002') {
                                    this.deviceTempAndFlow[1].temp = temp;
                                    this.deviceTempAndFlow[1].belowZero = (temp < 1)
                                }
                                if(id == 'Vitrafy-00004') {
                                    this.deviceTempAndFlow[2].temp = temp;
                                    this.deviceTempAndFlow[2].belowZero = (temp < 1)
                                }
                                if(id == 'Vitrafy-00006') {
                                    this.deviceTempAndFlow[3].temp = temp;
                                    this.deviceTempAndFlow[3].belowZero = (temp < 1)
                                }
                                if(id == 'Vitrafy-00009') {
                                    this.deviceTempAndFlow[7].temp = temp;
                                    this.deviceTempAndFlow[7].belowZero = (temp < 1)
                                }
                            }

                            if (element[0].TagID == "pids_lc_flow_pid_pv") {
                                var deviceFlowActual = element[0].TagValue.toFixed(1);

                                if(id == 'Vitrafy-00001') this.deviceTempAndFlow[0].flow = deviceFlowActual;
                                if(id == 'Vitrafy-00002') this.deviceTempAndFlow[1].flow = deviceFlowActual;
                                if(id == 'Vitrafy-00004') this.deviceTempAndFlow[2].flow = deviceFlowActual;
                                if(id == 'Vitrafy-00006') this.deviceTempAndFlow[3].flow = deviceFlowActual;
                                if(id == 'Vitrafy-00009') this.deviceTempAndFlow[7].flow = deviceFlowActual;
                            }
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            timeCalculator: function(seconds) {
                let y = Math.floor(seconds / 31536000);
                let mo = Math.floor((seconds % 31536000) / 2628000);
                let d = Math.floor(((seconds % 31536000) % 2628000) / 86400);
                let h = Math.floor((seconds % (3600 * 24)) / 3600);
                let m = Math.floor((seconds % 3600) / 60);
                let s = Math.floor(seconds % 60);

                let yDisplay = y > 0 ? y + (y === 1 ? " year, " : " years, ") : "";
                let moDisplay = mo > 0 ? mo + (mo === 1 ? " month, " : " months, ") : "";
                let dDisplay = d > 0 ? d + (d === 1 ? " day, " : " days, ") : "";
                let hDisplay = h > 0 ? h + (h === 1 ? " hour, " : " hours, ") : "";
                let mDisplay = m > 0 ? m + (m === 1 ? " minute " : " minutes, ") : "";
                let sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds ") : "";
                return yDisplay + moDisplay + dDisplay + hDisplay + mDisplay + sDisplay + "ago";
            },
            async getBlockchain() {
                this.errorDetails = null;
                this.blockchain = [];
                this.blockchainInProgress = [];
                this.blockchainCompleted = [];
                this.blockchainTemplates= [];

                let headers = {
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };

                try {
                    const response = await this.$http.get(
                        "https://mcaloon.org/GetAllAssets",
                        {headers: headers}
                    );
                    this.blockchain = response.data.body;
                    
                    console.log(this.blockchain);

                    // filter blockchain
                    var temp = [];
                    var ts;
                    var tsa;

                    for (var i = 0; i < this.blockchain.length; i++) {
                        ts = new Date(parseInt(this.blockchain[i].TimeStamp));
                        this.blockchain[i].datetime = ts;

                        temp.push(this.blockchain[i])

                        var idt = this.blockchain[i].ID.toString().split(':');
                        this.blockchain[i].displayid = idt[0];
                        this.blockchain[i].TimeStamp = idt[1];
                        this.blockchain[i].TimeStampEpoch = idt[1];
                        this.blockchain[i].name = idt[2];

                        ts = new Date(parseInt(this.blockchain[i].TimeStamp));
                        // tsa = ts.toString().split('GMT');
                        // ts = tsa[0];
                        // this.blockchain[i].TimeStamp = ts;

                        tsa = ts.toLocaleString('en-AU').toUpperCase();
                        var tsb = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + tsa;
                        this.blockchain[i].TimeStamp = tsb.replace(',', '');                    

                        // create text version of current state
                        if(this.blockchain[i].State == "0") {
                            this.blockchain[i].StateText = "1. Doctor Patient Identification (in progress)";
                            this.blockchain[i].stateProgress = 0;
                        }
                        if(this.blockchain[i].State == "1") {
                            this.blockchain[i].StateText = "2. Patient Collection (in progress)";
                            this.blockchain[i].stateProgress = 8.3;
                        }
                        if(this.blockchain[i].State == "2") {
                            this.blockchain[i].StateText = "3. Isolation Leukapheresis (in progress)";
                            this.blockchain[i].stateProgress = 16.6;
                        }
                        if(this.blockchain[i].State == "3") {
                            this.blockchain[i].StateText = "4. Vitrafy Controlled Cryopreservation (in progress)";
                            this.blockchain[i].stateProgress = 24.9;
                        }        
                        if(this.blockchain[i].State == "4") {
                            this.blockchain[i].StateText = "5. Specialised Logistics (in progress)";
                            this.blockchain[i].SensorData = "21";
                            this.blockchain[i].stateProgress = 33.2;
                        }       
                        if(this.blockchain[i].State == "5") {
                            this.blockchain[i].StateText = "6. Vitrafy Controlled Biothaw (in progress)";
                            this.blockchain[i].stateProgress = 41.5;
                        }
                        if(this.blockchain[i].State == "6") {
                            this.blockchain[i].StateText = "7. Differentiation Transformation (in progress)";
                            this.blockchain[i].stateProgress = 49.8;
                        }
                        if(this.blockchain[i].State == "7") {
                            this.blockchain[i].StateText = "8. Expansion (in progress)";
                            this.blockchain[i].stateProgress = 58.1;
                        }    
                        if(this.blockchain[i].State == "8") {
                            this.blockchain[i].StateText = "9. Vitrafy Controlled Cryopreservation (in progress)";
                            this.blockchain[i].stateProgress = 66.4;
                        }    
                        if(this.blockchain[i].State == "9") {
                            this.blockchain[i].StateText = "10. Specialised Logistics (in progress)";
                            this.blockchain[i].stateProgress = 74.7;
                        }    
                        if(this.blockchain[i].State == "10") {
                            this.blockchain[i].StateText = "11. Vitrafy Controlled Biothaw (in progress)";
                            this.blockchain[i].stateProgress = 83;
                        }    
                        if(this.blockchain[i].State == "11") {
                            this.blockchain[i].StateText = "12. Transplant (in progress)";
                            this.blockchain[i].stateProgress = 91.3;
                        }    
                        if(this.blockchain[i].State == "COMPLETE") {
                            this.blockchain[i].StateText = "Smart Contract Completed";
                            this.blockchain[i].stateProgress = 100;
                        }                                                                                                                                                                            
                    }

                    this.blockchain = temp;

                    // reorder devices by creation time
                    this.blockchain.sort(function(a, b){
                        if(a.TimeStampEpoch > b.TimeStampEpoch) { return -1; }
                        if(a.TimeStampEpoch < b.TimeStampEpoch) { return 1; }
                        return 0;
                    })

                    // split blockchain into "In Progress" and "Completed"
                    for (i = 0; i < this.blockchain.length; i++) {
                        if(this.blockchain[i].State != "template") {
                            //if(this.blockchain[i].State > "11" || this.blockchain[i].Owner == "Vitrafy") {
                            if(this.blockchain[i].State == "COMPLETE" || this.blockchain[i].Owner == "Vitrafy" || this.blockchain[i].Owner == "vitrafy") {

                                // remove some of the test contracts 
                                var hideCOntractList = [
                                    "test 123",
                                    "test",
                                    "test phoebe",
                                    "demo 1",
                                    "Eli test",
                                    "test111",
                                    "Eli Test",
                                    "test 123123123",
                                    "123"
                                ]

                                if(!hideCOntractList.includes(this.blockchain[i].name)) {
                                    this.blockchainCompleted.push(this.blockchain[i]);
                                }
                            } else {
                                // DISABLED
                                this.blockchainInProgress.push(this.blockchain[i]);
                            }

                            // FOR TESTING
                            //this.blockchainInProgress.push(this.blockchain[i]);

                        } else {
                            //this.blockchain[i].TempData = JSON.stringify(this.blockchain[i].TempData);

                            try {
                                this.blockchain[i].TempData = JSON.parse(this.blockchain[i].TempData);
                            } catch(err) {
                                console.log(err);
                            }

                            this.blockchainTemplates.push(this.blockchain[i]);
                        }
                    }
                    
                    this.blockchainInProgressCount = "In Progress (" + this.blockchainInProgress.length + ")";
                    this.blockchainCompletedCount = "Completed (" + this.blockchainCompleted.length + ")";
                    this.blockchainTemplatesCount = "Templates (" + this.blockchainTemplates.length + ")";

                    console.log("blockchainInProgress = " + this.blockchainInProgress.length);
                    console.log("blockchainCompleted = " + this.blockchainCompleted.length);                

                    document.getElementById("blockchain-data-loading").style.display = 'none';
                    document.getElementById("blockchain-table").style.display = 'block';

                    // hide blockchain error message
                    document.getElementById("blockchain-data-loading-error").style.display = 'none';
                } catch (error) {
                    console.log(error);
                    document.getElementById("blockchain-data-loading").style.display = 'none';
                    document.getElementById("blockchain-data-loading-error").style.display = 'block';
                    this.errorDetails = error;
                }            
            },
            async CreateAsset() {
                // hide table show loading spinner 
                document.getElementById("blockchain-data-loading").style.display = 'block';
                document.getElementById("blockchain-table").style.display = 'none';
    
                var blockId = this.uuidv4();
                
                var timestamp = new Date().getTime();
                blockId = blockId + ":" + timestamp + ":" + this.contractName;

                var data = {
                    "ID": blockId,
                    "TimeStamp": timestamp,
                    "State": "0",
                    "Owner": "Vitrafy (version 2)",
                    "User": this.userInfo.username,
                    "TempData": ""
                };

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };

                try {
                    const response = await this.$http.post(
                        "https://mcaloon.org/CreateAsset",
                        data,
                        {headers: headers}
                    );
                    this.blockchain = response.data;
                    
                    console.log(this.blockchain);
                    this.getBlockchain();

                } catch (error) {
                    console.log(error);
                }            
            },
            blockchainStageComplete: async function(block) {
                // hide table show loading spinner 
                document.getElementById("blockchain-data-loading").style.display = 'block';
                document.getElementById("blockchain-table").style.display = 'none';

                console.log('blockchainStageComplete button clicked!');  
                var timestamp = new Date().getTime();

                // get latest sensor data
                console.log("waiting for sensor data");
                var latestSensorData = await this.getLatestSensorData();
                latestSensorData = latestSensorData.split(" ");
                latestSensorData = latestSensorData[0] + " " + latestSensorData[1] + "C " + latestSensorData[2] + "%";
                console.log("SENSOR DATA received [OK]");
                console.log("latestSensorData = " + latestSensorData);
                console.log("writting to blockchain");

                var newState = parseInt(block.State) + 1;

                if(newState == 12) {
                    newState = "COMPLETE";
                }

                var data = {
                    "ID": block.ID,
                    "TimeStamp": timestamp,
                    "State": newState,
                    "Owner": block.Owner,
                    "User": block.User,
                    "TempData": latestSensorData
                };

                console.log(data)            

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };               

                try {
                    const response = await this.$http.post(
                        "https://mcaloon.org/UpdateAsset",
                        data,
                        {headers: headers}
                    );
                    this.blockchain = response.data;
                    
                    console.log(this.blockchain);
                    this.getBlockchain();

                } catch (error) {
                    console.log(error);
                }      
            },
            async ReadAssetHistory(block) {
                var data = {
                    "ID": block.ID,
                };

                data = JSON.stringify(data);

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                };

                const ReadAssetHistoryURL = "https://mcaloon.org/ReadAssetHistory";

                try {
                    const response = await this.$http.post(
                        ReadAssetHistoryURL,
                        data,
                        {headers: headers}
                    );                

                    // append history to block
                    block.history = response.data;

                    for (var x = 0; x < response.data.length; x++) {
                        if(response.data[x].State == "0") {    
                            block.stage0 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "1") {    
                            block.stage1 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "2") {
                            block.stage2 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "3") {
                            block.stage3 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "4") {
                            block.stage4 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "5") {
                            block.stage5 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "6") {
                            block.stage6 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "7") {
                            block.stage7 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "8") {
                            block.stage8 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "9") {
                            block.stage9 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "10") {
                            block.stage10 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "11") {
                            block.stage11 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }
                        if(response.data[x].State == "COMPLETE") {
                            block.stage12 = this.convertBlockTimestamp(response.data[x].TimeStamp);
                        }                        
                    }
                } catch (error) {
                    console.log(error);
                }    
            },
            convertBlockTimestamp: function(timestamp) {
                var ts = new Date(parseInt(timestamp));     
                var tsa = ts.toLocaleString('en-AU').toUpperCase();
                var tsb = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + tsa;
                ts = tsb.replace(',', '');
                return ts;
            },
            openNewContractModal: function() {
                // clear contractName
                this.contractName = '';
                this.contractApplication = null;
                this.contractTemplate = null;
            },
            createNewContract: function(){
                console.log('create new contract button clicked!');
                console.log('contract name = ' + this.contractName);
                this.CreateAsset();
            },
            earthClick: function() {
                var currentURL = window.location.href;
                console.log(currentURL);
                window.location.assign(currentURL + "earth");
            },
            pi2DataClick: function() {
                this.playSound("play","Displaying current Temperature and Humidity Sensor readingsfrom the design lab.");

                console.log("pi2DataClick!");

                // fetch data
                this.fetchSensorData = true;

                // hide table show loading spinner 
                document.getElementById("live-data-loading").style.display = 'block';
                document.getElementById("live-data-container").style.display = 'none';
            },
            pi2DataHide: function() {
                // stop data fetch
                this.fetchSensorData = false;
                console.log("pi2DataHide function from parent!");
            },
            openNav: function() {
                console.log("mobile nav opened");
                document.getElementById("mySidenav").style.width = "100%";
                document.getElementById("mobile_nav_items").style.display = "block";
                document.getElementById("mobile_nav_items").classList.remove("animate__fadeOut");
            },
            closeNav: function() {
                console.log("mobile nav closed");
                document.getElementById("mySidenav").style.width = "0%";
                document.getElementById("mobile_nav_items").classList.add("animate__fadeOut");
            },
            clearTable: function() {
                this.sensorData = [];

                this.piData.data.labels = [];
                this.piData.data.datasets[0].data = [];
                this.piData.data.datasets[1].data = [];           
            },
            autoFetch: function () {
                if (this.autofetch) {
                    // turn off auto update
                    this.autofetch = false;
                } else {
                    // turn on auto update
                    this.autofetch = true;      
                    this.getSensorData();
                }
            },
            async getTrackingData() {
                try {
                    let url = "https://2eyqm30671.execute-api.ap-southeast-2.amazonaws.com/beta/lifelink";
                    let headers = {
                        'x-api-key': 'NMKFcHIzMT7ToX0O9eRXW7yXA22zGM0B7ddc8Xpy'
                    };

                    const response = await this.$http.get(
                        url,
                        {headers: headers}
                    );

                    //console.log(response.data.Items);

                    // sort by timestamp
                    response.data.Items.sort(function(x, y){
                        return x.TIMESTAMP - y.TIMESTAMP;
                    })                
                    
                    for(var i = 0; i < response.data.Items.length; i++) {
                        // add row number
                        response.data.Items[i].rowNumber = i + 1;

                        // format timestamp
                        var ts = new Date(parseInt(response.data.Items[i].TIMESTAMP + '000'));
                        response.data.Items[i].formattedTimestamp = ts.toLocaleString('en-AU').toUpperCase();
                        response.data.Items[i].formattedTimestamp = ts.toLocaleString('en-us', {  weekday: 'short' }) + ' ' + response.data.Items[i].formattedTimestamp;
                        response.data.Items[i].formattedTimestamp = response.data.Items[i].formattedTimestamp.replace(',', '');
                        
                        // clean up date (remove any leading or trailing "'")
                        if(response.data.Items[i].CELLID.substr(-1) === "'") {
                            response.data.Items[i].CELLID = response.data.Items[i].CELLID.substr(0, response.data.Items[i].CELLID.length - 1);
                        }
                        if(response.data.Items[i].LAC.substr(-1) === "'") {
                            response.data.Items[i].LAC = response.data.Items[i].LAC.substr(0, response.data.Items[i].LAC.length - 1);
                        }
                        if(response.data.Items[i].MNC.substr(-1) === "'") {
                            response.data.Items[i].MNC = response.data.Items[i].MNC.substr(0, response.data.Items[i].MNC.length - 1);
                        }
                        if(response.data.Items[i].RSSI[0] === "'") {
                            response.data.Items[i].RSSI = response.data.Items[i].RSSI.substr(1);
                        }
                        
                                        
                    }

                    // reverse order
                    response.data.Items = response.data.Items.reverse();   

                    // data for table
                    this.trackingDataAll = response.data.Items;

                    var trackingDataRpi4G = [];
                    var trackingDataRpi4G02 = [];

                    // seperate data
                    for(i = 0; i < this.trackingDataAll.length; i++) {
                        if(this.trackingDataAll[i].ID == 'Rpi-4G') {
                            trackingDataRpi4G.push(this.trackingDataAll[i]);
                        }
                        if(this.trackingDataAll[i].ID == 'Rpi-4G-02') {
                            trackingDataRpi4G02.push(this.trackingDataAll[i]);
                        }                    
                    }

                    this.trackingDataRpi4G = trackingDataRpi4G;
                    this.trackingDataRpi4G02 = trackingDataRpi4G02;

                    // set tab heading
                    this.tabTrackingDataAll = 'All (' + this.trackingDataAll.length + ')';
                    this.tabTrackingDataRpi4G = 'Rpi4G (' + this.trackingDataRpi4G.length + ')';
                    this.tabTrackingDataRpi4G02 = 'Rpi4G-02 (' + this.trackingDataRpi4G02.length + ')';

                    // render map baded on current tab
                    this.trackingTabChanged(localStorage.tab);

                

                } catch (error) {
                    console.log(error);
                }
            },
            async getLocationTest(row) {
                //console.log('test api click');
                // getLocationTest from AddGoogleMap.vue
                this.$refs.googleMaps.getLocationTest(row);
            },
            trackingTabChanged: function(tab) {
                console.log("tab changed to tab " + tab);
                localStorage.tab = tab;

                // set map to latest valid location for selected tab
                if(localStorage.tab == 0) {
                    for(var i = 0; i < this.trackingDataAll.length; i++) {
                        if(this.trackingDataAll[i].CELLID.length > 0) {
                            this.$refs.googleMaps.getLocationTest(this.trackingDataAll[i]);
                            break;
                        }
                    }
                }
                if(localStorage.tab == 1) {
                    for(i = 0; i < this.trackingDataRpi4G.length; i++) {
                        if(this.trackingDataRpi4G[i].CELLID.length > 0) {
                            this.$refs.googleMaps.getLocationTest(this.trackingDataRpi4G[i]);
                            break;
                        }
                    }
                }
                if(localStorage.tab == 2) {
                    for(i = 0; i < this.trackingDataRpi4G02.length; i++) {
                        if(this.trackingDataRpi4G02[i].CELLID.length > 0) {
                            this.$refs.googleMaps.getLocationTest(this.trackingDataRpi4G02[i]);
                            break;
                        }
                    }          
                }                      
                
            },
            async audioPlay(fileName) {
                console.log('start timer');
                var audio = new Audio(this.audioPath + fileName);
                await new Promise(resolve => setTimeout(resolve, 1000));  // 200ms delay
                console.log('after 1sec');
                audio.play();
                this.voiceChangeLoading = false;
                this.voiceTestLoading = false;        
                this.restoreVoiceTestLoading = false;
            },
            async restoneVoiceTest() {
                this.voiceSelected = "Olivia,neural";
                this.voiceLanguageSelected = "en-AU";
                localStorage.voiceSelected = this.voiceSelected;
                localStorage.voiceLanguageSelected = this.voiceLanguageSelected;
                this.getVoices();
                this.restoreVoiceTestLoading = true;
                await this.playSound("play","Default voice Olivia neural restored");
            },
            async changeVoice() {
                localStorage.voiceSelected = this.voiceSelected;
                localStorage.voiceLanguageSelected = this.voiceLanguageSelected;
                this.voiceChangeLoading = true;
                await this.playSound("play","voice changed to " + this.voiceSelected);
            },            
            async voiceTest() {
                this.voiceTestLoading = true;
                await this.playSound("play",this.voiceText, true);
            },
            async playSound(action, voice, test) {
                // only process if enabled
                if(this.AIChecked || action == "off") {
                    if(voice) {
                        //voice = "custom speech";
                    } else {
                        console.log(action);
                        console.log(this.userInfo);

                        // -------------------
                        // Voice logic (test)
                        // -------------------
                        var firstName = "";
                        console.log(this.userName);

                        if(this.userName == "smcaloon"){
                            firstName = "Simon";
                        } else if (this.userName == "smason"){
                            firstName = "Scott"
                        } else {
                            firstName = "life chain user"
                        }

                        if(action == "on") {
                            // // generate greeting
                            // var greetings = [
                            //     "hello " + firstName,
                            //     "hi " + firstName,
                            //     "hey " + firstName,
                            //     firstName + ", it's Nice to see you",
                            //     "Good to see you " + firstName,
                            //     "Great to see you " + firstName,
                            //     firstName + " Long time no see",
                            //     "It's been a while " + firstName,
                            //     "yo " + firstName,
                            //     "whats up",
                            //     "sup",
                            //     "heyyy",
                            //     "hiya",
                            //     "ahoy",
                            //     "hello stranger",
                            //     "goodmorrow",
                            //     "what's cracking",
                            //     "what's up buttercup",
                            //     "howdy",
                            //     "hey mate"
                            // ]

                            // console.log("greetings = " + greetings.length)

                            // var index = parseInt(Math.random() * greetings.length);
                            // console.log("index = " + index);
                            // voice = greetings[index]

                            var hours = new Date().getHours();
                            console.log(hours);

                            var ampm = (hours >= 12) ? "PM" : "AM";
                            console.log(ampm);                        

                            var timeBasedGreeting = ""
                            if(ampm == "AM") {
                                timeBasedGreeting = "Good morning";
                            } else {
                                if(hours >= 18) {
                                    timeBasedGreeting = "Good evening";
                                } else {
                                    timeBasedGreeting = "Good afternoon";
                                }
                            }

                            // greeting - use name       
                            voice = timeBasedGreeting + " " + firstName;

                            // greeting - introduction
                            voice = timeBasedGreeting + ", my name is Lily. I'm the LifeChain Virtual Assistant. How can I help you today?";

                            // TEMP FIX for tracking page (which reloads on click - needs to fix, realted to vitrafyEarth intergration)
                            if(localStorage.nav == "tracking") {
                                voice = "displaying current global locations of Life Link devices";
                            }
                        } 
                        if(action == "off") {
                            // // generate farwell
                            // //voice = 'Bye for now';

                            // var farwells = [
                            //     "bye",
                            //     "take it easy",
                            //     "I'm off",
                            //     "see you later",
                            //     "see ya later",
                            //     "bye, bye",
                            //     "goodbye",
                            //     "have a nice day"                            
                            // ]

                            // index = parseInt(Math.random() * farwells.length);
                            // voice = farwells[index];

                            // voice = "Life Chain virtual assistant disabled. Goodbye.";
                            voice = "Goodbye.";
                        }
                    }

                    voice = "<speak>" + voice + "</speak>";

                    // -------------------
                    // Voice logic (test)
                    // -------------------
                    console.log("play sound test");
                    console.log("voiceLanguageSelected = " + this.voiceLanguageSelected);

                    // get voice details from localstorage
                    var voiceSelected = localStorage.voiceSelected;
                    var voiceLanguageSelected = localStorage.voiceLanguageSelected;

                    // if this is a voice test overwrite with values from data model 
                    if(test) {
                        voiceSelected = this.voiceSelected;
                        voiceLanguageSelected = this.voiceLanguageSelected;
                    }

                    var data = {
                        "Engine": voiceSelected.split(",")[1],
                        "LanguageCode": voiceLanguageSelected,
                        "Text": voice,
                        "TextType": 'ssml',
                        "OutputFormat": 'mp3',
                        "VoiceId": voiceSelected.split(",")[0]
                    };

                    data = JSON.stringify(data);

                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'API-Key': process.env.VUE_APP_BLOCKCHAIN_API_KEY
                    };            

                    try {
                        const response = await this.$http.post(
                            "https://mcaloon.org/PollyTest",
                            data,
                            {headers: headers}
                        );
                        
                        var x = response.data;
                        console.log(x);

                        this.audioPlay(x);

                        console.log("playing audio...");


                    } catch (error) {
                        console.log(error);
                    }
                }
            },
            async getLatestSensorData() {
                let url = "https://xct6d7fy58.execute-api.ap-southeast-2.amazonaws.com/beta";
                let headers = {
                    'x-api-key': 'NMKFcHIzMT7ToX0O9eRXW7yXA22zGM0B7ddc8Xpy'
                };

                try {
                    const response = await this.$http.get(
                        url,
                        {headers: headers}
                    );

                    console.log("--- sensor data ---")
                    //console.log(response.data)
                    return response.data.Items[0].itemData[29].deviceTempData;

                } catch (error) {
                    console.log(error);
                }
            },
            doSomethingOnHidden: function() {
                console.log("MODAL CLOSED!!!");
            },
            dynamicGreeting: function() {
                // dynamic greeting
                var hours = new Date().getHours();
                console.log(hours);

                var ampm = (hours >= 12) ? "PM" : "AM";
                console.log(ampm);                        

                var userName = "Simon";
                var timeBasedGreeting = ""
                if(ampm == "AM") {
                    timeBasedGreeting = "Good morning";
                } else {
                    if(hours >= 18) {
                        timeBasedGreeting = "Good evening";
                    } else {
                        timeBasedGreeting = "Good afternoon";
                    }
                }
                this.dashboardDynamicGreeting = timeBasedGreeting + " " + userName + " " + "👋";                
            }
        },    
        watch: {

        },    
        created() {

        },
        mounted: function () {
            // Display core vue app element
            const appElement = document.getElementById('app');
            appElement.style.display = 'block';

            window.document.title = "Sensor Dashboard";
            this.getLifeLinkData();
            // ---------- All auto fetch data calls ----------
            // LifeLInk API auto-fetch
            this.timer = setInterval(() => {
                this.getLifeLinkData();
            }, 30000) // 30 sec
        }
    }
</script>

